var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-fade-transition',[_c('router-view',_vm._g(_vm._b({attrs:{"name":_vm.name}},'router-view',_vm.$attrs,false),_vm.$listeners)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }